<template>
  <div>
	<h2 class="text-capitalize">Categories: 
		<button type="button" class="btn btn-orange ml-2" aria-label="Close" @click="toggleTerm(slug)" v-for="slug in termSlugs" :key="slug">
			<span aria-hidden="true">&times; {{slug}}</span>
		</button>
	</h2>
	<p class="fz-24 text-center animated fadeIn p-64" v-if="showNoResults">No Results</p>
	<div class="row" v-if="!showNoResults">
		<div class="col-lg-4 product-item my-3 animated fadeInUp" v-for="post in posts" :key="post.ID">
			<a class="d-block position-relative" :href="post.link" :aria-label="post.post_title">
				<div class="bg-image-wrap">
					<div class="bg-image p-20 bg-light-gray d-flex justify-content-center align-items-center">
						<img :src="post.image_url" alt="">
					</div>
				</div> 
				<div class="overlay d-flex align-items-left justify-content-center flex-column px-4">
					<p class="mb-0 fz-16 text-center">Explore this model</p>
				</div>
			</a>
			<div class="py-2"><p class="fz-16 mb-0 ff-heading color-orange">{{post.post_title}}</p></div>
		</div>
	</div>
    <div class="row" style="overflow-anchor: none;">
      <button class="btn btn-orange mx-auto" @click.stop.prevent="loadMore()" v-if="showLoadMore">Load More Products</button>
    </div>
  </div>
</template>
<script>
const axios = require('axios');
export default {
	created(){
		this.q = this.getUrlParam('q','');
		this.$set(this.termSlugs,)
		this.termSlugs = app.products.productsNavigationApp.checkedTerms = this.q.split(',');
		// this.updateTerms();
		this.setTerms();
		this.getPosts();
		this.showLoadMore = false;
	},
	mounted(){
		// this.showLoadMore = true;
	},
	computed: {
		productHeadingTermString(){
			let termString = "";
			let index = 0;
			for (const [key, termSlug] of Object.entries(this.termSlugs)) {
				if(this.terms[termSlug]){
					if(index>0)	termString += " and " + this.terms[termSlug].name;
					else termString += this.terms[termSlug].name;
				}
				index++;
			}
			return termString;
		}
	},
	methods: {
		getPostRequest(page = 1, take = 12, search = ''){
			this.showNoResults = false;
			this.showLoadMore = false;
			return axios.get(`${this.api.prefix}${this.api.posts}?page=${page}&take=${take}&terms=${this.termSlugs}&search=${search}&q=${this.q}`);
		},
		getPosts(page = 1, take = 12){
			this.$set(this, 'loading', true);
			this.getPostRequest(page, take)
				.then(posts => {
					if(posts.data.posts.length == 0 ){
						this.showNoResults = true;
					} else{
						this.$set(this, 'loading', false);
						this.delayedInsert(this.posts, posts.data.posts);
						if(posts.data.found_posts <= take*page){
							this.showLoadMore = false;
						} else{
							setTimeout(() => {
								this.showLoadMore = true;
							}, 300);
						}
					}
				}).catch(err => {
					this.$set(this, 'loading', false);
				});
		},
		loadMore(){
			this.$set(this, 'page', this.page + 1);
			this.getPosts(this.page);
		},
		searchPosts(searchString){
			this.q = '';
			this.productHeading = "Searching all products for: " + searchString;
			this.$set(this, 'terms', 'all');
			this.$set(this, 'page', 1);
			this.$set(this, 'searchString', searchString);
			this.$set(this, 'loading', true);
			this.getPostRequest(1, 12, searchString).then(response => {
				this.$set(this, 'loading', false);
				this.$set(this, 'posts', []);
				if(response.data.length == 0){
					// console.log(response.data);
					this.showLoadMore = false;
					if(this.page==1){
						this.showNoResults = true;
					}
				}
				this.delayedInsert(this.posts, response.data.posts);
				if(response.data.length < 12){
					this.showLoadMore = false;
				} else{
					setTimeout(() => {
						this.showLoadMore = true;
					}, 300);
				}
			});
			// app.scroll.toTarget('.section-products');
		},
		deleteSlug(slug){
			console.log('deleting'+slug);
		},
		// updateTerms(){
		// 	this.inc;
		// 	this.termSlugs.forEach((slug,index) => {
		// 		this.getTermBySlug(slug).then(term => {
		// 			this.$set(this.terms, term.data.slug, term.data);
		// 		});
		// 	});
		// },
		// setTerm(slug, heading){
		// 	this.q = '';
		// 	this.productHeading = heading + " Products";
		// 	this.$set(this, 'term', slug);
		// 	this.$set(this, 'page', 1);
		// 	this.$set(this, 'loading', true);
		// 	this.getPostRequest(this.term).then(response => {
		// 		this.$set(this, 'loading', false);
		// 		this.$set(this, 'posts', []);
		// 		if(response.data.length == 0){
		// 			this.showNoResults = true;
		// 		}
		// 		this.delayedInsert(this.posts, response.data);
		// 		if(response.data.length < 12){
		// 			this.showLoadMore = false;
		// 		} else{
		// 			setTimeout(() => {
		// 				this.showLoadMore = true;
		// 			}, 300);
		// 		}
		// 	});
		// 	app.scroll.toTarget('.section-products');
		// },
		resetTerms(){
			this.termSlugs = [];
			this.q = [];
			this.$set(this, 'posts', []);
			this.getPosts();
		},
		toggleTerm(slug){
			this.q = '';
			this.$set(this, 'posts', []);
			if(this.termSlugs.indexOf(slug) > -1){
				this.termSlugs.splice(this.termSlugs.indexOf(slug),1);
			}
			else{
				this.termSlugs.push(slug);
			}
			// this.updateTerms();
			this.getPosts();

			// this.$set(this, 'term', slug);
			// this.$set(this, 'page', 1);
			// this.$set(this, 'loading', true);
			// this.getPostRequest(this.term).then(response => {
			// 	this.$set(this, 'loading', false);
			// 	this.$set(this, 'posts', []);
			// 	if(response.data.length == 0){
			// 		this.showNoResults = true;
			// 	}
			// 	this.delayedInsert(this.posts, response.data);
			// 	if(response.data.length < 12){
			// 		this.showLoadMore = false;
			// 	} else{
			// 		setTimeout(() => {
			// 			this.showLoadMore = true;
			// 		}, 300);
			// 	}
			// });
			// app.scroll.toTarget('.section-products');
		},
		getTermBySlug(slug){
			return axios.get(`${this.api.prefix}term/?slug=${slug}`);
		},
		setTerms(){
			axios.get(`${this.api.prefix}terms/`).then(response => {
				response.data.forEach(term => {
					this.$set(this.terms, term.slug, term);
				});
			});
		},
		delayedInsert(subject, items){
			const [item, ...rest] = items;
			subject.push(item);
			if (rest.length > 0){
				setTimeout(() => {
					this.delayedInsert(subject, rest);
				}, 80);
			}
		},
		setMode(mode){
			this.$set(this, 'mode', mode);
		},
		json(j){
			return JSON.stringify(j);
		},
		getUrlParam(parameter, defaultvalue){
			var urlparameter = defaultvalue;
			if(window.location.href.indexOf(parameter) > -1){
				urlparameter = this.getUrlVars()[parameter];
				}
			return urlparameter;
		},
		getUrlVars() {
			var vars = {};
			var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
				vars[key] = value;
			});
			return vars;
		}
	},
	data() {
		return {
			inc: 0,
			posts: [],
			categories: [],
			// term: 'all',
			loading: true,
			api: {
				prefix: '/wp-json/usdp/v1/',
				posts: 'products/'
			},
			page: 1,
			// searchString: '',
			showNoResults: true,
			showLoadMore: false,
			mode: 'grid',
			terms: {},
			termSlugs: {},
			productHeading: 'All Products',
			q: ''
		};
	}
}
</script>
